import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-uncalledleads',
  templateUrl: './uncalledleads.component.html',
  styleUrls: ['./uncalledleads.component.css']
})
export class UncalledleadsComponent implements OnInit {

  constructor() { }

  @Input() title:any;
  @Input() icon:any;
  @Input() value:any;
  @Input() per:any;
  @Input() width:any;
  @Input() bgcolor:any;
  @Input() goal:any;
  @Input() collection:any;

  ngOnInit() {
  }

}
